export default "__VITE_ASSET__38357203__"